import { inject, Injectable } from '@angular/core';
import { DocumentType } from '@app/core/enums/document/document-type.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Document } from '@app/core/model/entities/document/document';
import { DocumentsService } from '@app/features/main/views/organization-documents/documents.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class PicturesService {
  private documentsService = inject(DocumentsService);

  public assetId: string;
  public images: Document[] = [];

  /**
   * Fetch and return an Asset's pictures from the API.
   * @param assetId ID of the Asset whose picture should be fetched.
   * @return Observable of picture documents.
   */
  public loadData(assetId: string): Observable<Document[]> {
    this.images = [];
    this.assetId = assetId;
    return this.documentsService.loadEntityDocuments(assetId, EntityTypeEnum.ASSET, DocumentType.PICTURE)
      .pipe(tap(pictures => this.images = pictures));
  }

  public addImage(image: Document): void {
    this.images.push(image);
  }

  public reset(): void {
    // reset assetId onDestroy asset sheet for force reload asset pictures on next display asset sheet
    this.assetId = undefined;
    this.images = [];
  }
}
